import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface RevertToDraftDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const titleId = 'revert-to-draft-dialog-title';
const descriptionId = 'revert-to-draft-dialog-description';

// Shown before a save that would change a Submitted project's data. Users must not
// discover the status change afterwards: a Draft drops out of the submitted-projects
// counts the dashboards report, so a silent revert reads as data loss.
//
// Uses MUI's Button rather than StyledButton for the same reason DiscardChangesDialog
// does - StyledButton renders a plain <div> and is not keyboard-operable inside MUI's
// dialog focus trap.
const RevertToDraftDialog = ({ open, onCancel, onConfirm }: RevertToDraftDialogProps) => (
  <Dialog
    open={open}
    onClose={onCancel}
    aria-labelledby={titleId}
    aria-describedby={descriptionId}
  >
    <DialogTitle id={titleId}>Saving will return this project to Draft</DialogTitle>
    <DialogContent>
      <DialogContentText id={descriptionId}>
        This project has already been submitted. Saving these changes returns it to Draft,
        and it will need to be submitted again before it counts as a submitted project.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button variant="outlined" onClick={onCancel}>Cancel</Button>
      <Button variant="contained" onClick={onConfirm}>Save and return to Draft</Button>
    </DialogActions>
  </Dialog>
);

export default RevertToDraftDialog;
